const contactBn = {
	breadcrumbs: { home: 'হোম', contact: 'যোগাযোগ' },
	hero: {
		title: 'আমাদের সাথে যোগাযোগ করুন',
		subtitle: 'আপনার যেকোনো প্রশ্ন, মতামত বা সহায়তার জন্য আমরা এখানে আছি'
	},
	quick: {
		title: 'দ্রুত সাহায্য পান',
		actions: {
			liveChat: { title: 'লাইভ চ্যাট', desc: 'তাৎক্ষণিক সাহায্য পান', cta: 'চ্যাট শুরু করুন' },
			helpCenter: { title: 'সাহায্য কেন্দ্র', desc: 'সাধারণ প্রশ্নের উত্তর', cta: 'সাহায্য দেখুন' },
			business: { title: 'ব্যবসায়িক অনুসন্ধান', desc: 'পার্টনারশিপ ও সহযোগিতা', cta: 'যোগাযোগ করুন' }
		}
	},
	info: {
		title: 'যোগাযোগের তথ্য',
		service: { title: 'কাস্টমার সার্ভিস', desc: 'সকাল ৯টা থেকে রাত ৯টা পর্যন্ত' },
		email: { title: 'ইমেইল', desc: '২৪ ঘন্টার মধ্যে উত্তর পাবেন' },
		address: {
			title: 'ঠিকানা',
			desc: 'শনিবার থেকে বৃহস্পতিবার, ৯টা-৬টা',
			primary: 'বাড়ি #১২, কলেজ রোড,',
			secondary: 'দুখা ফকিরের মোড়, গুরুদাসপুর, নাটোর - ৬৪৪০'
		}
	},
	form: {
		title: 'মেসেজ পাঠান',
		desc: 'আপনার তথ্য দিয়ে ফর্মটি পূরণ করুন। আমরা ২৪ ঘন্টার মধ্যে যোগাযোগ করব।',
		name: 'নাম',
		email: 'ইমেইল',
		phone: 'ফোন',
		subject: 'বিষয়',
		message: 'মেসেজ',
		messagePh: 'আপনার প্রশ্ন বা মন্তব্য বিস্তারিত লিখুন...',
		submit: 'পাঠিয়ে দিন',
		success: 'আপনার মেসেজ সফলভাবে পাঠানো হয়েছে। আমরা শীঘ্রই যোগাযোগ করব।'
	},
	hours: {
		title: 'অফিস সময়',
		weekdays: 'শনিবার - বৃহস্পতিবার',
		friday: 'শুক্রবার',
		note: 'প্রতি শুক্রবার অফিসের কার্যক্রম লিমিটেড থাকবে কারন এটা সরকারি ছুটির দিন'
	},
	social: { title: 'সোশ্যাল মিডিয়া' },
	faq: {
		title: 'প্রায়শই জিজ্ঞাসিত প্রশ্ন',
		subtitle: 'আপনার প্রশ্নের উত্তর হয়তো আমাদের সাহায্য বিভাগে রয়েছে',
		cta: 'সাহায্য কেন্দ্র দেখুন'
	}
};

export default contactBn;


